import { DATE_FORMATS } from "@/constants";
import { DatePicker, Form, FormInstance, FormProps, Input } from "antd";
import dayjs from "dayjs";

interface ContactFormProps extends FormProps {
    initialValues: Partial<Contact>;
    onFinish: (values: CreateContactRequest) => void;
    form: FormInstance,
}

export function ContactForm({
    initialValues,
    onFinish,
    form,
    ...props
}: ContactFormProps) {

    return (
        <Form
            onFinish={onFinish}
            form={form}
            initialValues={{
                ...initialValues,
                pickUpDate: initialValues.pickUpDate ? dayjs(initialValues.pickUpDate) : undefined,
                pickUpTime: initialValues.pickUpTime ? dayjs(initialValues.pickUpTime, DATE_FORMATS.REQUEST_TIME_FORMAT) : undefined,
            }}
            layout="vertical"
            {...props}
            className="!pt-4"
        >
            <Form.Item
                name={"title"}
                label="Title"
                rules={[{ required: true, message: "Please enter the title!" }]}
            >
                <Input
                    placeholder="Title"
                    size="large"
                />
            </Form.Item>

            <div
                className="grid grid-cols-2 gap-4"
            >
                <Form.Item
                    name={"driverName"}
                    label="Driver Name"
                    rules={[{ required: true, message: "Please enter the driver's name!" }]}
                >
                    <Input
                        placeholder="Driver Name"
                        size="large"
                    />
                </Form.Item>
                <Form.Item
                    name={"phone"}
                    label="Driver's Phone Number"
                    rules={[
                        { required: true, message: "Please enter the driver's phone!" },
                        { pattern: /^09\d{6,9}$/, message: "Invalid phone number!" }
                    ]}
                >
                    <Input
                        placeholder="Driver's Phone Number"
                        size="large"
                    />
                </Form.Item>
            </div>

            <div
                className="grid grid-cols-2 gap-4"
            >
                <Form.Item
                    name={"pickUpDate"}
                    label="Date"
                    rules={[{ required: true, message: "Please select time!" }]}
                >
                    <DatePicker
                        placeholder="Select Date"
                        size="large"
                        className="w-full"
                        disabledDate={(current) => current && current < dayjs().add(1, "day").startOf("day")}
                        inputReadOnly
                    />
                </Form.Item>
                <Form.Item
                    name={"pickUpTime"}
                    label="Time"
                    rules={[{ required: true, message: "Please select date!" }]}
                >
                    <DatePicker.TimePicker
                        format={"hh:mm A"}
                        placeholder="Select Time"
                        size="large"
                        className="w-full"
                        // disabledTime={(current) => {
                        //     const currentTime = dayjs();
                        //     return {
                        //         disabledHours: () => {
                        //             const hours = [];
                        //             for (let i = 0; i < currentTime.hour(); i++) {
                        //                 hours.push(i);
                        //             }
                        //             return hours;
                        //         },
                        //         disabledMinutes: () => {
                        //             if (currentTime.hour() === current.hour()) {
                        //                 const minutes = [];
                        //                 for (let i = 0; i < currentTime.minute(); i++) {
                        //                     minutes.push(i);
                        //                 }
                        //                 return minutes;
                        //             }
                        //             return [];
                        //         },
                        //         disabledSeconds: () => [],
                        //     };
                        // }}
                        inputReadOnly
                    />
                </Form.Item>
            </div>

            <Form.Item
                name={"address"}
                label="Address"
                rules={[{ required: true, message: "Please enter the address!" }]}
            >
                <Input.TextArea
                    placeholder="Address"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    size="large"
                />
            </Form.Item>
        </Form>
    )
}
